import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, onyx} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {},
  header: {
    paddingVertical: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItemText: {
    color: onyx,
  },
  bonusProgressBar: {
    paddingVertical: indent * 0.8,
    borderBottomColor: cloudLight,
    borderBottomWidth: 1,
  },
});
